/**
 * useBulkSelectionGate — shared "selection-count-gated button" logic for the
 * inventory bulk-action triggers (bulk spec download, bulk photo download).
 *
 * Both triggers disable their button and show a tooltip when the current
 * selection is empty or exceeds the action's unit cap. This hook centralizes
 * that threshold check so each trigger only owns its own icon/label/click
 * handler and the actual translated tooltip copy.
 */

export type BulkSelectionGateTooltipKey = 'empty' | 'cap' | null;

export interface UseBulkSelectionGateResult {
  /** True when the selection is empty or exceeds the cap. */
  isDisabled: boolean;
  /** Which disabled-state tooltip copy the caller should render, if any. */
  tooltipKey: BulkSelectionGateTooltipKey;
}

export function useBulkSelectionGate(count: number, cap: number): UseBulkSelectionGateResult {
  const isDisabled = count === 0 || count > cap;
  const tooltipKey: BulkSelectionGateTooltipKey =
    count === 0 ? 'empty' : count > cap ? 'cap' : null;
  return { isDisabled, tooltipKey };
}
